import { useEffect, useState } from 'react'
import { AppShell } from '@app/shell/AppShell'
import { useSession } from '@shared/lib/auth/session-store'

function buildLoginUrl() {
  const redirect = `${window.location.pathname}${window.location.search}`
  return `/login?redirect=${encodeURIComponent(redirect)}`
}

export function AuthGate() {
  const token = useSession((state) => state.token)
  const [hasHydrated, setHasHydrated] = useState(() => useSession.persist.hasHydrated())

  useEffect(() => {
    if (hasHydrated) {
      return undefined
    }

    return useSession.persist.onFinishHydration(() => {
      setHasHydrated(true)
    })
  }, [hasHydrated])

  useEffect(() => {
    if (hasHydrated && !token) {
      window.location.replace(buildLoginUrl())
    }
  }, [hasHydrated, token])

  if (!hasHydrated || !token) {
    return null
  }

  return <AppShell />
}
